import { ContainerComponent, wrap } from 'AppReact';
import internalState from './internalState';
import { Td, FlexCenterJustifyCenterWrapper } from 'wrappers';
import { OutlinedButton } from 'molecules';
import Controller from './controller';

export const definition = {
  name: 'DisabledCell',
  controller: Controller,
  initialProps: ({ card, makeReadyCategories, makeReadyCategory }) => ({ card, makeReadyCategories, makeReadyCategory }),
  props: internalState,
  elements: [
    {
      wrapper: Td,
      name: 'TD',
      displayState: ({ card, makeReadyCategories, makeReadyCategory }) => {
        if (makeReadyCategories?.find(c => c.index === (makeReadyCategory.index ?? 0) + 1)?.type === 'task') {
          return { borderRight: '0px solid red !important', background: card.hidden ? '#F7F7F7' : '#F4FCF8' }
        }
        return { background: card.hidden ? '#F7F7F7' : '#F4FCF8' }
      },
      elements: [
        {
          component: wrap(OutlinedButton, FlexCenterJustifyCenterWrapper),
          name: 'Reactivate',
          renderIf: ({ card, makeReadyCategories, makeReadyCategory }) => makeReadyCategory.index === makeReadyCategories.filter(c => c.active).find(c => c.type === 'task')?.index && card.hidden,
          bindings: () => ({ title: "Reactivate" }),
        },
        {
          component: wrap(OutlinedButton, FlexCenterJustifyCenterWrapper),
          name: 'Archive',
          renderIf: ({ card, makeReadyCategories, makeReadyCategory }) => makeReadyCategory.index === makeReadyCategories.filter(c => c.active).find(c => c.type === 'task')?.index && !card.hidden && card.completed_on && !window.settings.use_integration_for_make_ready_archiving,
          bindings: () => ({ title: "Archive" }),
        },
      ]
    }
  ]
}

export default ContainerComponent(definition)